/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Title_Project_ImportInputs */



/**
* | output |
* | --- |
* | "Project Import" |
*
* @param {Ateliere_Connect_Title_Project_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_title_project_import = /** @type {((inputs?: Ateliere_Connect_Title_Project_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Title_Project_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektimport")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de proyectos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトのインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट आयात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de Projetos")
	return /** @type {LocalizedString} */ ("Project Import")
});